export const NUMBER_ONLY = new RegExp(/[^\d]/, "gm")

export const COMMA_ONLY = new RegExp(/\,/, "g")

export const DECIMAL_NUMBERS_ONLY = new RegExp(/[^\d|^\.|^\,]/, "gm")